import { api } from "../client";
import {
  PartialUserUserAbsenceFields,
  UserUserAbsenceFields,
} from "../schema/UserUserAbsence";
import { Config, ConfigMutate } from "../types";

type ApiRequestConfig = Config<UserUserAbsenceFields>;
type ApiRequestConfigMutate = ConfigMutate<PartialUserUserAbsenceFields, []>;

export const getUserUserAbsences = async (config?: ApiRequestConfig) => {
  return api.get<UserUserAbsenceFields>("user_user_absences", config);
};
export const getUserUserAbsence = (id: number, config?: ApiRequestConfig) => {
  return api.get<UserUserAbsenceFields>(`user_user_absences/${id}`, config);
};

export const createUserUserAbsence = (config: ApiRequestConfigMutate) => {
  return api.create<PartialUserUserAbsenceFields>("user_user_absences", config);
};
export const updateUserUserAbsence = (
  id: number,
  config?: ApiRequestConfigMutate
) => {
  return api.update<PartialUserUserAbsenceFields>(
    `user_user_absences/${id}`,
    config
  );
};
export const deleteUserUserAbsence = (id: number) => {
  return api.remove<UserUserAbsenceFields>(`user_user_absences/${id}`);
};
